import { Navbar, Nav, Container, Row, Col, Button } from 'react-bootstrap';

const VibeSteps = () => {
  return (true == true ) ? (
    <div style={{
      maxWidth:600,
      margin:'auto',
      paddingTop:25,
      paddingBottom:25
    }}>
    <p style={{textAlign:'center'}} className="maincolumntext">Is it relaxing? Is the food amazing? Is it relaxing, beautiful, or upbeat? Is there great people watching? Can I bring my dog or kid? Do you love the music? Is it a hidden gem? Do the locals hang here?</p>
    </div>
  ):(
    <Row className="padrow">

      <Col>
      <div style={{background:'#dedede',padding:25,borderRadius:5}}>
      Hit the vibe button.
      </div>
      </Col>
      <Col>
      <div style={{background:'#dedede',padding:25,borderRadius:5}}>
      Pick a vibe!
      </div>
      </Col>
      <Col>
      <div style={{background:'#dedede',padding:25,borderRadius:5}}>
      Add a picture.
      </div>
      </Col>
      <Col>
      <div style={{background:'#dedede',padding:25,borderRadius:5}}>
      Add a short comment.
      </div>
      </Col>

    </Row>
  )
}
export default VibeSteps
